<div
  class="offcanvas-start sidebar offcanvas px-3"
  tabindex="-1"
  id="sidebar"
  aria-labelledby="sidebarLabel"
  [ngClass]="{ 'sidebar-fixed': !isHomePage }"
>
  <div class="offcanvas-header">
    <button
      type="button"
      class="btn-close btn-close-white py-1"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      [ngClass]="{
        'd-block': isHomePage,
        'd-lg-none': !isHomePage
      }"
    ></button>
  </div>
  <div class="mt-2">
    <div
      class="userDet d-flex align-items-center pb-2 pt-2 px-2"
      translate="no"
      *ngIf="isAuthenticated"
    >
      <a class="pl-0 logoU" (click)="onEditProfileClick()">
        <span class="edit d-flex align-items-center justify-content-center"
          ><i class="fa-solid fa-pencil"></i
        ></span>
        <div class="imgOut me-2">
          <img
            [src]="user?.profileImg"
            onerror="this.src='/assets/images/default-profile-individual.png'"
            class="rounded-circle"
            alt="default profile image"
          />
        </div>
      </a>
      <div class="userN">
        <a
        class="pfname pt-1"
        (click)="onEditProfileClick()"
      >
        {{ user?.name }}
      </a>
      <span class="userDetails ">{{ cleanNumber(user?.mobile) }}</span>
      </div>
    
    </div>
    <ul class="nav flex-column mt-4">
      <ng-container *ngFor="let item of menuItems">
         <!-- Divider before FAQ -->
        <li *ngIf="item.label === 'FAQs'">
          <hr class="divider my-3" />
        </li>

        <li
          class="nav-item"
          *ngIf="(!item['requiresAuth'] || isAuthenticated) &&
          (item.label !== 'Buy Ticket' || (leftMenu && leftMenu.allow_to_register === 1)) &&
          (item.label !== 'Digital Catalog' || (leftMenu && leftMenu.show_digital_catalog))"
          (click)="onMenuClick(item)"
          data-bs-dismiss="offcanvas"
          [ngClass]="{ 'low-opacity': isLowOpacityItem(item)}"
        >
          <a class="nav-link" [ngClass]="{ 'no-flex': item.imgLabel }">

             <!-- Icon -->
          <img class="me-3" [src]="item.icon" *ngIf="item.icon"/>

              <!-- TEXT LABEL or IMAGE LABEL -->
          <ng-container *ngIf="item.imgLabel; else showTextLabel">
            <img [src]="item.imgLabel" class="label-img" alt="{{ item.label }}" />
          </ng-container>

          <ng-template #showTextLabel>
            {{ item.label }}
          </ng-template>

            <div class="blink-dot" *ngIf="item.label === 'Fill Ticket Forms'"></div>
          </a>
        </li>
      </ng-container>

    </ul>
  </div>
</div>
